import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\maximus\\components\\courses\\CourseDetails.jsx");
